import { FC } from 'react';
import CrossSvg from '@edikk-edikk/country-layout-black-icon/src/cross.svg';
import { SvgIcon } from '@edikk-edikk/svg-icon';
import { Button, ButtonSize, ButtonVariant } from '@edikk-edikk/country-layout-black';
import { useAdvertDetailContext } from '#advertDetail/hooks';

const GalleryHeaderClose: FC = () => {
  const { onClose } = useAdvertDetailContext();

  if (!onClose) {
    return null;
  }

  return (
    <Button variant={ButtonVariant.black} size={ButtonSize.lg} circle onClick={onClose} aria-label="Close">
      <SvgIcon Component={CrossSvg} isWithoutFill />
    </Button>
  );
};

export { GalleryHeaderClose };
